import { gql } from '@apollo/client';

export const OFFERS_CHANGED_SUBSCRIPTION = gql`
  subscription OffersChanged($soId: String!) {
    offersChanged(soId: $soId)
  }
`;
